import { UserType } from "interfaces";

const ADMIN_HOSTNAMES = [
  "uat-workspace-admin.actiup.net",
  "workspace-admin.actiup.net",
];

const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0"];

type AuthUserType = UserType.ADMIN | UserType.WPS;

const isAuthUserType = (value?: string | null): value is AuthUserType => {
  return value === UserType.ADMIN || value === UserType.WPS;
};

export const getAuthUserType = (): AuthUserType => {
  const hostname = window.location.hostname;
  const isLocalhost = LOCAL_HOSTNAMES.includes(hostname);

  if (ADMIN_HOSTNAMES.includes(hostname)) {
    return UserType.ADMIN;
  }

  if (isLocalhost) {
    const params = new URLSearchParams(window.location.search);
    const queryType = params.get("type") ?? params.get("user_type");

    if (isAuthUserType(queryType)) {
      return queryType;
    }

    const envType = process.env.REACT_APP_AUTH_TYPE;
    if (isAuthUserType(envType)) {
      return envType;
    }

    return UserType.ADMIN;
  }

  return UserType.WPS;
};

export const getAuthLogo = (type: AuthUserType) => {
  if (type === UserType.WPS) {
    return {
      src: "images/logo/logo-wps.png",
      alt: "Actiup WPS Logo",
      className: "mx-auto h-14 w-auto object-contain",
    };
  }

  return {
    src: "images/logo/colored.png",
    alt: "Actiup Logo",
    className: "mx-auto h-20 w-auto",
  };
};
